import { Plus, Rocket02, SearchLg } from '@untitled-ui/icons-react/build/cjs';
import React from 'react';
import ButtonCmp from 'src/components/ButtonCmp';

interface IProps {
    title: any;
    icon?: any;
    iconSecondary?: any;
    desc: any;
    containerClassName?: string;
    contentClassName?: string;
    iconClassName?: string;
    iconSecondaryClassName?: string;
    testId?: string;
    descClass?: string;
    titleClassName?: string;
    EmptyStateWithCircle?: boolean;
    EmptyStateWithCleanSlate?: boolean;
    EmptyStateCircleRingCommonClass?: string;
    footerWrapClass?: string;

    // button 1 props
    buttonText?: any;
    buttonDisabled?: boolean;
    btnClass?: string;
    buttonType?: string;
    buttonClassName?: string;
    handleActionType?: () => void;
    btnIcon?: any;
    btnIconSideRight?: boolean;

    // button 2 props
    buttonText2?: any;
    buttonDisabled2?: boolean;
    btnClass2?: string;
    buttonClassName2?: string;
    handleActionType2?: () => void;
    showButtonIcon2?: boolean;
    btnIcon2?: any;
    buttonType2?: string;
    isEmptyBackground?: boolean;
    isFixedHeight?: boolean;
}

const NotFoundUI = ({
    title,
    desc,
    containerClassName = '',
    contentClassName = '',
    iconSecondaryClassName = '',
    icon,
    iconSecondary,
    iconClassName = '',
    testId,
    descClass,
    titleClassName,
    EmptyStateWithCircle,
    EmptyStateWithCleanSlate,
    EmptyStateCircleRingCommonClass,
    footerWrapClass,

    // button 1 props
    buttonText,
    buttonDisabled,
    btnClass,
    buttonType,
    buttonClassName,
    handleActionType,
    btnIcon,
    btnIconSideRight,

    // button 2 props
    buttonText2,
    buttonDisabled2,
    btnClass2,
    buttonClassName2,
    handleActionType2,
    showButtonIcon2 = true,
    btnIcon2,
    buttonType2,
    isEmptyBackground = true,
    isFixedHeight,
}: IProps) => (
    <div
        data-test-id={testId}
        className={`h-full flex mx-4 items-center justify-center overflow-hidden ${containerClassName} ${EmptyStateWithCircle ? '  my-5 py-9' : 'my-[61px]'} ${
            isFixedHeight ? '!h-auto min-h-[175px] !my-0 !py-0' : ''
        } `}
    >
        <div
            className={` ${contentClassName} px-5 max-w-[480px] flex items-center justify-center flex-col z-[0] relative ${EmptyStateWithCleanSlate && 'py-[40px]'} ${
                !EmptyStateWithCircle &&
                !EmptyStateWithCleanSlate &&
                !isEmptyBackground &&
                "before:[''] before:bg-[url('../../assets/img/not-found-images/empty-state.png')] before:w-full before:h-[calc(100%+200px)] before:absolute before:z-[-1] before:bg-no-repeat before:bg-center"
            }`}
        >
            {EmptyStateWithCircle || EmptyStateWithCleanSlate ? (
                <div className={`${EmptyStateWithCleanSlate ? '[&>div:not(:first-child)]:w-11 [&>div:not(:first-child)]:h-11' : 'w-11 h-11'} rounded-full relative mb-3`}>
                    {EmptyStateWithCleanSlate ? (
                        <div className="w-[170px] rounded-lg border border-utilityGray100 bg-gray25 mb-1">
                            <div className="border-b border-utilityGray200 p-2 flex justify-between">
                                <div className="rounded w-[41%] h-3.5 bg-utilityGray200"></div>
                                <div className="rounded w-[29%] h-3.5 bg-utilityGray200"></div>
                            </div>
                            <div className="p-2 flex justify-between">
                                <div className="rounded w-full h-6 bg-utilityGray200"></div>
                            </div>
                        </div>
                    ) : (
                        <>
                            <div className={`${iconClassName} rounded-[10px] border border-utilityGray200 shadow-sm h-full w-full bg-white text-textSecondary flex items-center justify-center `}>
                                {icon ?? <SearchLg className="w-5 h-5" />}
                            </div>
                            <div className={`${iconSecondaryClassName} hidden rounded-full h-full w-full bg-gradient-to-b from-gray50 to-utilityGray500 text-grayLight900 items-center justify-center`}>
                                {iconSecondary ?? <Rocket02 className="w-5 h-5 text-primary" />}
                            </div>
                        </>
                    )}
                    <div
                        className={`border border-utilityGray100 w-full h-full rounded-full absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 -z-[1] p-[47px]
              ${EmptyStateCircleRingCommonClass || ''}
            `}
                    ></div>
                    <div
                        className={`border border-utilityGray100 w-full h-full rounded-full absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 -z-[1] opacity-80 p-[79px]
              ${EmptyStateCircleRingCommonClass || ''}
            `}
                    ></div>
                    <div
                        className={`border border-utilityGray100 w-full h-full rounded-full absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 -z-[1] opacity-60 p-[111px]
              ${EmptyStateCircleRingCommonClass || ''}
            `}
                    ></div>
                    <div
                        className={`border border-utilityGray100 w-full h-full rounded-full absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 -z-[1] opacity-40 p-[143px]
              ${EmptyStateCircleRingCommonClass || ''}
            `}
                    ></div>
                    <div
                        className={`border border-utilityGray100 w-full h-full rounded-full absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 -z-[1] opacity-20 p-[175px]
              ${EmptyStateCircleRingCommonClass || ''}
            `}
                    ></div>
                </div>
            ) : (
                <>
                    <div className={`${iconClassName} rounded-[10px] border border-utilityGray200 shadow-sm h-11 w-11 bg-white text-textSecondary flex items-center justify-center mb-3`}>
                        {icon ?? <SearchLg className="w-5 h-5" />}
                    </div>
                    <div className={`${iconSecondaryClassName} hidden rounded-full h-14 w-14 bg-gradient-to-b from-gray50 to-utilityGray500 text-grayLight900 items-center justify-center mb-3`}>
                        {iconSecondary ?? <Rocket02 className="w-5 h-5 text-primary" />}
                    </div>
                </>
            )}

            <div className="[&>div]:px-5">
                <div className={`text-center text-grayLight900 text-sm font-semibold leading-5 ${titleClassName} `}>{title}</div>
                <div className={`sm:max-w-[342px] mx-auto p-1 text-center text-grayLight600 text-xs font-normal leading-[18px] ${descClass} `}>{desc}</div>
            </div>
            {(buttonText || buttonText2) && (
                <div className={`flex gap-3 mt-4 ${footerWrapClass}`}>
                    {handleActionType && buttonText && buttonText !== 'false' && (
                        <div className={`${btnClass}`}>
                            <ButtonCmp
                                type="button"
                                className={`${buttonClassName} ${buttonType ? buttonType : 'btn-outline-primary'}  btn-heigh-auto shadow`}
                                onClick={handleActionType}
                                disabled={buttonDisabled}
                                iconSide={btnIconSideRight ? 'right' : 'left'}
                                icon={btnIcon ? btnIcon : <Plus className="w-4 h-4" />}
                            >
                                {buttonText}
                            </ButtonCmp>
                        </div>
                    )}

                    {handleActionType2 && buttonText2 && buttonText2 !== 'false' && (
                        <div className={`${btnClass2}`}>
                            <ButtonCmp
                                type="button"
                                className={`${buttonClassName2} ${buttonType2 ? buttonType2 : 'btn-outline-primary '} btn-heigh-auto shadow`}
                                onClick={handleActionType2}
                                disabled={buttonDisabled2}
                                icon={btnIcon2 ? btnIcon2 : showButtonIcon2 ? <Plus className="w-4 h-4" /> : ''}
                            >
                                {buttonText2}
                            </ButtonCmp>
                        </div>
                    )}
                </div>
            )}
        </div>
    </div>
);

export default NotFoundUI;
